import * as React from "react";
import type { SVGProps } from "react";
const SvgPieChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.131 16.28a1 1 0 1 0-1.842-.78zM8.4 3.746a1 1 0 0 0-.8-1.834zM22 12v1a1 1 0 0 0 1-1zM12 2V1a1 1 0 0 0-1 1zm0 10h-1a1 1 0 0 0 1 1zm8.289 3.5a9 9 0 0 1-2.608 3.476l1.262 1.55a11 11 0 0 0 3.188-4.247zm-2.608 3.476a9 9 0 0 1-3.933 1.848l.389 1.962a11 11 0 0 0 4.806-2.26zm-3.933 1.848a9 9 0 0 1-4.34-.21l-.576 1.915a11 11 0 0 0 5.305.257zm-4.34-.21a9 9 0 0 1-3.736-2.219l-1.406 1.423a11 11 0 0 0 4.566 2.711zm-3.736-2.219a9 9 0 0 1-2.261-3.71l-1.909.598a11 11 0 0 0 2.764 4.535zm-2.261-3.71a9 9 0 0 1-.26-4.337l-1.965-.366a11 11 0 0 0 .316 5.3zm-.26-4.337a9 9 0 0 1 1.804-3.954L3.389 5.15a11 11 0 0 0-2.203 4.832zm1.804-3.954A9 9 0 0 1 8.4 3.747l-.8-1.834A11 11 0 0 0 3.39 5.15zM23 12a11 11 0 0 0-.837-4.21l-1.848.766A9 9 0 0 1 21 12zm-.837-4.21a11 11 0 0 0-2.385-3.568l-1.414 1.414a9 9 0 0 1 1.95 2.92zm-2.385-3.568a11 11 0 0 0-3.568-2.385l-.766 1.848a9 9 0 0 1 2.92 1.951zM16.21 1.837A11 11 0 0 0 12 1v2a9 9 0 0 1 3.444.685zM11 2v10h2V2zm1 11h10v-2H12z"
    />
  </svg>
);
export default SvgPieChart;
